// Pause a product-page video once less than a quarter of it is on screen.
//
// In the stacked desktop gallery a playing film scrolls out of view and its voice carries on over
// the rest of the page. Nothing resumes it: the customer presses play again if they want it back.
//
// <video-media> (theme.js) sets a "playing" attribute and fires a bubbling "media:play" event for
// Shopify-hosted and YouTube/Vimeo films alike, and its pause() handles all three. Watching starts
// on that event, so galleries re-rendered by a variant change are covered without a rescan.

const VISIBLE_SHARE = 0.25;
const watched = new WeakSet();

const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      // The first report arrives as soon as watching starts; a film the customer has just started
      // is never paused on that one.
      if (!watched.has(entry.target)) {
        watched.add(entry.target);
        continue;
      }

      if (entry.intersectionRatio < VISIBLE_SHARE && entry.target.hasAttribute('playing')) {
        entry.target.pause();
      }
    }
  },
  { threshold: [0, VISIBLE_SHARE] }
);

document.addEventListener('media:play', (event) => {
  const media = event.target.closest?.('video-media');

  if (media && !watched.has(media)) {
    observer.observe(media);
  }
});
